module.exports = __webpack_public_path__ + "img/IMG_2629_P_L_Foamcore_MockedUp.2b5a1b7e.jpg";